// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Action from '../Action';
import Icon from '../Icon';

import '../../helpers/base.less';
import './Status.less';

const intentIconMap = {
    success: 'circle-check-mark-filled',
    info: 'circle-info-filled',
    warning: 'circle-exclamation-mark-filled',
    danger: 'circle-exclamation-mark-filled',
};

/**
 * `Status` component.
 */
const Status = ({ baseClassName, className, children, icon, intent, progress, ...props }) => {
    if (intent === 'inactive') {
        intent = 'muted';
    }

    return (
        <Action
            component="span"
            icon={
                Icon.create(icon || intentIconMap[intent], {
                    name: intentIconMap[intent],
                })
            }
            className={classNames(
                baseClassName,
                {
                    [`${baseClassName}--${intent}`]: intent && !progress,
                },
                className
            )}
            progress={progress}
            {...props}
        >
            {children}
        </Action>
    );
};

Status.propTypes = {
    /**
     * Content of the `Status`.
     */
    children: PropTypes.node,
    /**
     * Icon of the Status.
     */
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element,
    ]),
    /**
     * Visual intent color to apply to component.
     */
    intent: PropTypes.oneOf([
        'danger',
        'warning',
        'success',
        'info',
        'muted',
    ]),
    /**
     * Right additional content.
     */
    rightAddon: PropTypes.node,
    /**
     * Bottom additional content.
     */
    bottomAddon: PropTypes.node,
    /**
     * Indicate the progress state of the `Status`.
     */
    progress: PropTypes.bool,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Status.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}status`,
    icon: null,
    intent: null,
    rightAddon: null,
    bottomAddon: null,
    progress: null,
};

export default Status;



// WEBPACK FOOTER //
// ./components/Status/Status.js